import { FormInstance } from "antd/es/form";
import React from "react";
import { IValidationData } from "../../models/dto/validation-data";
import { KContext } from "../../shared/hoc/with-context";
import { KNavigator } from "../../shared/hoc/with-history";
import { KuikaAppManager } from "../../shared/utilty/kuika-app-manager";
import { KMainFunctions } from "../../shared/utilty/main-functions";
import { ReactSystemFunctions } from "../../shared/utilty/react-system-functions";

declare let window: any;

interface IHediyeCeki_ScreenProps {
  navigator: KNavigator;
  form: FormInstance<any>;
  googleLogin: any;
  screenInputs: any;
  context: KContext;
  initialValues: any;
  children: any;
}

interface IHediyeCeki_ScreenState {
  isSpinnerVisible: boolean;
  isPageVisible: boolean;
  isLeftMenuVisible: boolean;
  spinnerCount: number;
  selectedLanguage: string;
  isPageInitLoaded: false;
  isPageRecurringLoaded: false;
  GetGiftCardData: any;
  GetGiftCardData_dummy: any;
  NAVIGATE: any;
  NAVIGATE_dummy: any;
  isComp374301Visible: "visible" | "hidden";
  isComp597511Visible: "visible" | "hidden";
  isComp177140Visible: "visible" | "hidden";
  isComp993772Visible: "visible" | "hidden";
  isComp702437Visible: "visible" | "hidden";
}

export class HediyeCeki_ScreenBase extends React.PureComponent<IHediyeCeki_ScreenProps, any> {
  ml = [
    {
      Id: "17674926-0bc7-4f1a-91e6-cf803751ca13",
      Name: "en_US",
      ShortName: "English",
      IsDefault: true,
      LanguagePhrases: []
    },
    {
      Id: "75fac4db-c1e9-4277-968b-300f75803b25",
      Name: "FixedValues",
      ShortName: "FixedValues",
      LanguagePhrases: [
        { Id: 477706, PropertyName: "value", Value: "Penti" },
        { Id: 63584, PropertyName: "value", Value: "Son Geçerlilik Tarihi" },
        { Id: 812159, PropertyName: "value", Value: "TL" },
        { Id: 955730, PropertyName: "value", Value: "Çek kullanım koşulları için" },
        { Id: 279975, PropertyName: "value", Value: "tıklayınız." },
        { Id: 638576, PropertyName: "value", Value: "Hediye olarak gönderdiniz." },
        { Id: 197474, PropertyName: "value", Value: "Hediye olarak gönderdiniz, bilgileri görmek için;" },
        { Id: 993772, PropertyName: "label", Value: "Hediye Bilgilerini Gör" },
        { Id: 702437, PropertyName: "label", Value: "Hediye Gönder" }
      ]
    }
  ];
  defaultML = "en_US";

  screenHash = "";

  constructor(props) {
    super(props);

    this.state = {
      isSpinnerVisible: false,
      isPageVisible: false,
      isLeftMenuVisible: false,
      spinnerCount: 0,
      selectedLanguage: "",
      isPageInitLoaded: false,
      isPageRecurringLoaded: false,
      GetGiftCardData: "",
      NAVIGATE: "",
      isComp374301Visible: "hidden",
      isComp597511Visible: "hidden",
      isComp177140Visible: "hidden",
      isComp993772Visible: "hidden",
      isComp702437Visible: "hidden"
    };

    this.state.isPageVisible = true;
  }

  async componentDidMount() {
    if (KuikaAppManager.isPageInitPrevented()) {
      KuikaAppManager.calculateAndSetBodyHeight("hediyeceki", "");
      return;
    }

    if (true) {
      await this.HediyeCekiPageInit();
    }

    KuikaAppManager.calculateAndSetBodyHeight("hediyeceki", "");
  }

  componentWillUnmount() {}

  componentDidUpdate = async (prevProps, prevState) => {
    KuikaAppManager.calculateAndSetBodyHeight("hediyeceki", "");
    if (prevProps?.location?.search !== (this.props as any)?.location?.search) {
      await this.HediyeCekiPageInit();
    }
  };

  fillFormInitValues() {
    this.props.form.setFieldsValue({});
  }

  setPageInitLoaded = (value: boolean) => {
    this.setState({ isPageInitLoaded: value });
  };

  setPageRecurringLoaded = (value: boolean) => {
    this.setState({ isPageRecurringLoaded: value });
  };

  clearFieldValidation = (changedValues: any) => {
    const fieldName = Object.keys(changedValues)[0];
    if (fieldName) {
      this.props.form.setFields([
        {
          name: fieldName,
          errors: []
        }
      ]);
    }
  };

  HediyeCekiPageInit = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (KuikaAppManager.handleValidations(this, validations)) {
      const invalidValidation = validations.find((v) => !v.isValid && v.condition);
      if (invalidValidation) {
        const fieldIdMatch = invalidValidation.formName.match(/\d+/);
        if (fieldIdMatch) {
          const fieldId = fieldIdMatch[0];
          const fieldElement = document.getElementById(fieldId);
          if (fieldElement) {
            fieldElement.scrollIntoView({ behavior: "smooth", block: "center" });
            (fieldElement as HTMLElement).focus();
          }
        }
      }
      return true;
    }

    let localVar = {
      GiftCardNumber_0: ReactSystemFunctions.convertToTypeByName(
        this.props.screenInputs.gc ?? this.props.screenInputs.gc,
        "string"
      )
    };

    KuikaAppManager.showSpinner(this);

    if (true) {
      KuikaAppManager.showSpinner(this);
    }
    let result = await KuikaAppManager.ApiRequest(this, "HediyeCeki/HediyeCekiPageInit", localVar);
    if (!KMainFunctions.IsResStatus2XX(result)) return true;

    stateVars.GetGiftCardData = result?.data.getGiftCardData;
    formVars.hediyeceki_482688_value = ReactSystemFunctions.toString(this, stateVars.GetGiftCardData?.validThroughText);
    formVars.hediyeceki_597511_value = ReactSystemFunctions.toString(this, stateVars.GetGiftCardData?.errorMessage);
    formVars.hediyeceki_42890_value = ReactSystemFunctions.toString(this, stateVars.GetGiftCardData?.amount);
    formVars.hediyeceki_128862_value = ReactSystemFunctions.toString(this, stateVars.GetGiftCardData?.code);
    stateVars.isComp374301Visible =
      ReactSystemFunctions.isNotEmpty(ReactSystemFunctions.toString(this, stateVars.GetGiftCardData?.code), null) ===
      true
        ? "visible"
        : "hidden";
    stateVars.isComp597511Visible =
      ReactSystemFunctions.isEmpty(ReactSystemFunctions.toString(this, stateVars.GetGiftCardData?.code), null) === true
        ? "visible"
        : "hidden";
    stateVars.isComp177140Visible =
      ReactSystemFunctions.isNotEmpty(ReactSystemFunctions.toString(this, stateVars.GetGiftCardData?.code), null) ===
      true
        ? "visible"
        : "hidden";
    stateVars.isComp993772Visible =
      ReactSystemFunctions.isNotEmpty(ReactSystemFunctions.toString(this, stateVars.GetGiftCardData?.code), null) ===
      true
        ? "visible"
        : "hidden";
    stateVars.isComp702437Visible =
      ReactSystemFunctions.isNotEmpty(ReactSystemFunctions.toString(this, stateVars.GetGiftCardData?.code), null) ===
      true
        ? "visible"
        : "hidden";
    this.props.form.setFieldsValue(formVars);

    await new Promise((resolve, reject) => {
      this.setState(stateVars, async () => {
        isErrorOccurred = await this.HediyeCekiPageInit1_();
        resolve();
      });
    });

    KuikaAppManager.hideSpinner(this);
    return isErrorOccurred;
  };
  HediyeCekiPageInit1_ = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (KuikaAppManager.handleValidations(this, validations)) {
      const invalidValidation = validations.find((v) => !v.isValid && v.condition);
      if (invalidValidation) {
        const fieldIdMatch = invalidValidation.formName.match(/\d+/);
        if (fieldIdMatch) {
          const fieldId = fieldIdMatch[0];
          const fieldElement = document.getElementById(fieldId);
          if (fieldElement) {
            fieldElement.scrollIntoView({ behavior: "smooth", block: "center" });
            (fieldElement as HTMLElement).focus();
          }
        }
      }
      return true;
    }

    stateVars.isComp374301Visible =
      ReactSystemFunctions.isNotEmpty(ReactSystemFunctions.toString(this, this.state.GetGiftCardData?.code), null) ===
      true
        ? "visible"
        : "hidden";
    formVars.hediyeceki_482688_value = ReactSystemFunctions.toString(
      this,
      this.state.GetGiftCardData?.validThroughText
    );

    formVars.hediyeceki_597511_value = ReactSystemFunctions.toString(this, this.state.GetGiftCardData?.errorMessage);

    stateVars.isComp597511Visible =
      ReactSystemFunctions.isEmpty(ReactSystemFunctions.toString(this, this.state.GetGiftCardData?.code), null) === true
        ? "visible"
        : "hidden";
    stateVars.isComp177140Visible =
      ReactSystemFunctions.isNotEmpty(ReactSystemFunctions.toString(this, this.state.GetGiftCardData?.code), null) ===
      true
        ? "visible"
        : "hidden";
    formVars.hediyeceki_42890_value = ReactSystemFunctions.toString(this, this.state.GetGiftCardData?.amount);

    formVars.hediyeceki_128862_value = ReactSystemFunctions.toString(this, this.state.GetGiftCardData?.code);

    formVars.hediyeceki_94849_value = ReactSystemFunctions.toString(this, this.state.GetGiftCardData?.code);

    stateVars.isComp993772Visible =
      ReactSystemFunctions.isNotEmpty(ReactSystemFunctions.toString(this, this.state.GetGiftCardData?.code), null) ===
      true
        ? "visible"
        : "hidden";
    stateVars.isComp702437Visible =
      ReactSystemFunctions.isNotEmpty(ReactSystemFunctions.toString(this, this.state.GetGiftCardData?.code), null) ===
      true
        ? "visible"
        : "hidden";

    this.props.form.setFieldsValue(formVars);
    this.setState(stateVars);
    KuikaAppManager.hideSpinner(this);

    this.setPageInitLoaded(true);
    return isErrorOccurred;
  };

  HediyeCekiComponent_279975_onClick = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (KuikaAppManager.handleValidations(this, validations)) {
      const invalidValidation = validations.find((v) => !v.isValid && v.condition);
      if (invalidValidation) {
        const fieldIdMatch = invalidValidation.formName.match(/\d+/);
        if (fieldIdMatch) {
          const fieldId = fieldIdMatch[0];
          const fieldElement = document.getElementById(fieldId);
          if (fieldElement) {
            fieldElement.scrollIntoView({ behavior: "smooth", block: "center" });
            (fieldElement as HTMLElement).focus();
          }
        }
      }
      return true;
    }
    KuikaAppManager.showSpinner(this);

    KuikaAppManager.prepareForNavigation();
    KuikaAppManager.addToPageInputVariables(
      "TermsOfUse",
      "ValidThrough",
      ReactSystemFunctions.toString(this, this.state.GetGiftCardData?.validThroughText)
    );

    stateVars.NAVIGATE = await ReactSystemFunctions.navigate(
      this,
      undefined,
      "HediyeCeki",
      "TermsOfUse",
      "",
      "7d969ddf-5801-4eb6-b92b-12be35bdd565",
      "813894",
      null,
      null,
      null,
      null,
      null,
      true
    );

    this.props.form.setFieldsValue(formVars);
    this.setState(stateVars);
    KuikaAppManager.hideSpinner(this);

    return isErrorOccurred;
  };

  async callCallbackFunction(diId) {
    let isErrorOccurred = false;
    let pageInitCallerNavDiIDs = [813894] as number[];
    if (window.kuika?.serverRequestCount > 0 && pageInitCallerNavDiIDs.indexOf(diId) > -1) {
      await this.HediyeCekiPageInit();
    }
  }
}
